// dashboard
// import Analytics from "pages/Dashboards/Analytics";
import Ecommerce from "pages/Dashboards/Ecommerce";
import ParentDashboard from "pages/Dashboards/ParentDashboard";


// navbar
import NavBars from "pages/Components/Navigation/Navbars";
import NavTabs from "pages/Components/Navigation/Tabs";
import NavigationBreadcrumb from "pages/Components/Navigation/NavigationBreadcrumb";
import Pagination from "pages/Components/Navigation/Pagination";


// auth
import Basic from "pages/AuthenticationInner/Login/Basic";
import LoginCover from "pages/AuthenticationInner/Login/LoginCover";
import LoginBoxed from "pages/AuthenticationInner/Login/LoginBoxed";
import LoginModern from "pages/AuthenticationInner/Login/LoginModern";

//Register
import BasicRegister from "pages/AuthenticationInner/Register/Basic";
import RegisterCover from "pages/AuthenticationInner/Register/RegisterCover";
import RegisterBoxed from "pages/AuthenticationInner/Register/RegisterBoxed";
import RegisterModern from "pages/AuthenticationInner/Register/RegisterModern";


// EmailVerify
import BasicEmailVerify from "pages/AuthenticationInner/VerifyEmail/Basic";
import EmailCover from "pages/AuthenticationInner/VerifyEmail/EmailCover";
import EmailModern from "pages/AuthenticationInner/VerifyEmail/EmailModern";

// TwoSteps
import BasicTwoSteps from "pages/AuthenticationInner/TwoSteps/Basic";
import TwoStepsCover from "pages/AuthenticationInner/TwoSteps/TwoStepsCover";
import TwoStepsBoxed from "pages/AuthenticationInner/TwoSteps/TwoStepsBoxed";
import TwoStepsModern from "pages/AuthenticationInner/TwoSteps/TwoStepsModern";

// Logout
import BasicLogout from "pages/AuthenticationInner/Logout/Basic";
import LogoutCover from "pages/AuthenticationInner/Logout/LogoutCover";
import LogoutBoxed from "pages/AuthenticationInner/Logout/LogoutBoxed";
import LogoutModern from "pages/AuthenticationInner/Logout/LogoutModern";

// Reset Password
import BasicResetPassword from "pages/AuthenticationInner/ResetPassword/Basic";
import ResetPasswordCover from "pages/AuthenticationInner/ResetPassword/ResetPasswordCover";
import ResetPasswordBoxed from "pages/AuthenticationInner/ResetPassword/ResetPasswordBoxed";
import ResetPasswordModern from "pages/AuthenticationInner/ResetPassword/ResetPasswordModern";

// Create Password
import BasicCreatePassword from "pages/AuthenticationInner/CreatePassword/Basic";
import CreatePasswordModern from "pages/AuthenticationInner/CreatePassword/CreatePasswordModern";
import CreatePasswordCover from "pages/AuthenticationInner/CreatePassword/CreatePasswordCover";
import CreatePasswordBoxed from "pages/AuthenticationInner/CreatePassword/CreatePasswordBoxed";
import Login from "pages/Authentication/Login";
import Logout from "pages/Authentication/LogOut";
import Pages404 from "pages/AuthenticationInner/Pages404";
import Register from "pages/Authentication/Register";
import UserProfile from "pages/Authentication/UserProfile";
import Account from "pages/Pages/Account";
import ComingSoon from "pages/AuthenticationInner/ComingSoon";
// import Offline from "pages/AuthenticationInner/Offline";
import Maintenance from "pages/AuthenticationInner/Maintenance";
import Settings from "pages/Pages/Settings";
// import Pricing from "pages/Pages/Pricing";
import Faqs from "pages/Pages/Faqs";
import ContactUs from "pages/Pages/ContactUs";
import FAQList from "pages/Ecommerce/FAQ/FAQList";
import UserList from "pages/User/UserList";
import FrequentyAskedQuestions from "assets/static/FrequentyAskedQuestions";
import ComingSoonPage from "pages/ComingSoon/ComingSoonPage";
import AnnouncementList from "pages/Announcements/AnnouncementList";
import AnnouncementDetail from "pages/Announcements/AnnouncementDetail";
import ViewAnnouncements from "pages/Announcements/ViewAnnouncements";
import ChangePassword from "pages/Authentication/ChangePassword";
import SystemSettings from "pages/SystemSettings";

// Teacher
import TeacherList from "pages/Teacher/TeacherList";
import { AddTeacher } from "pages/Teacher/AddTeacher";

// Class
import ClassList from "pages/Class/ClassList";
import { AddClass } from "pages/Class/AddClass";

// Student
import StudentList from "pages/Student/StudentList";

// Program
import ProgramList from "pages/Program/ProgramList";
import { AddStudent } from "pages/Student/AddStudent";

// AcademicYear
import AcademicYearList from "pages/AcademicYear/AcademicYearList";

// Attendance
import AttendanceList from "pages/Attendance/AttendanceList";
import DailyAttendance from "pages/Attendance/DailyAttendance";
import FeesList from "pages/Fees/FeesList";

// Salary
import SalaryList from "pages/Salary/SalaryList";

// DailyHourLog
import DailyHourLogList from "pages/DailyHourLog/DailyHourLogList";

// Homework
import HomeworkList from "pages/Homework/HomeworkList";

interface RouteObject {
  path: string;
  component: React.ComponentType<any>; // Use React.ComponentType to specify the type of the component
  exact?: boolean;
}

const authProtectedRoutes: Array<RouteObject> = [
  // Dashboard
  { path: "/", component: Login },
  { path: "/dashboard", component: Ecommerce },
  { path: "/parent-dashboard", component: ParentDashboard },

  // navigation
  { path: "/navigation-navbars", component: NavBars },
  { path: "/navigation-tabs", component: NavTabs },
  { path: "/navigation-breadcrumb", component: NavigationBreadcrumb },
  { path: "/navigation-pagination", component: Pagination },


  {path:"/faq-list", component: FAQList},
  

  {path:"/userlist", component: UserList},
  
    // College Management

  // System Settings
  {path:"/system-settings", component: SystemSettings},

  // pages
  { path: "/pages-account", component: Account },
  { path: "/pages-account-settings", component: Settings },
  { path: "/pages-faqs", component: Faqs },
  { path: "/pages-contact-us", component: ContactUs },

  // profile
  { path: "/user-profile", component: UserProfile },
  { path: "/change-password", component: ChangePassword },

  // product history

    // coming soon
    { path: "/coming-soon", component: ComingSoonPage },

    // Teacher
    { path: "/teachers", component: TeacherList },

    // Class
    { path: "/classes", component: ClassList },

    // Student
    { path: "/students", component: StudentList },

    // Program
    { path: "/programs", component: ProgramList },

    // AcademicYear
    { path: "/academic-years", component: AcademicYearList },

    // User
    { path: "/application-users", component: UserList },

    // Attendance
    { path: "/monthly-attendance", component: AttendanceList },
    { path: "/daily-attendance", component: DailyAttendance },
    { path: "/student-fees", component: FeesList },

    // Salary
    { path: "/teacher-salary", component: SalaryList },

    // DailyHourLog
    { path: "/daily-hour-log", component: DailyHourLogList },

    // Homework
    { path: "/homework", component: HomeworkList },

    { path: "/announcement-list", component: AnnouncementList },
    

];

const publicRoutes = [
   { path: "/", component: Login },

  // auth
  { path: "/auth-login-basic", component: Basic },
  { path: "/auth-login-cover", component: LoginCover },
  { path: "/auth-login-boxed", component: LoginBoxed },
  { path: "/auth-login-modern", component: LoginModern },

  // Register
  { path: "/auth-register-basic", component: BasicRegister },
  { path: "/auth-register-cover", component: RegisterCover },
  { path: "/auth-register-boxed", component: RegisterBoxed },
  { path: "/auth-register-modern", component: RegisterModern },

  // Verify Email
  { path: "/auth-verify-email-basic", component: BasicEmailVerify },
  { path: "/auth-verify-email-cover", component: EmailCover },
  { path: "/auth-verify-email-modern", component: EmailModern },

  // two steps
  { path: "/auth-two-steps-basic", component: BasicTwoSteps },
  { path: "/auth-two-steps-cover", component: TwoStepsCover },
  { path: "/auth-two-steps-boxed", component: TwoStepsBoxed },
  { path: "/auth-two-steps-modern", component: TwoStepsModern },

  // logout
  { path: "/auth-logout-basic", component: BasicLogout },
  { path: "/auth-logout-cover", component: LogoutCover },
  { path: "/auth-logout-boxed", component: LogoutBoxed },
  { path: "/auth-logout-modern", component: LogoutModern },

  //Reset Password
  { path: "/auth-reset-password-basic", component: BasicResetPassword },
  { path: "/auth-reset-password-cover", component: ResetPasswordCover },
  { path: "/auth-reset-password-boxed", component: ResetPasswordBoxed },
  { path: "/auth-reset-password-modern", component: ResetPasswordModern },

  //Create Password
  { path: "/auth-create-password-basic", component: BasicCreatePassword },
  { path: "/auth-create-password-cover", component: CreatePasswordCover },
  { path: "/auth-create-password-boxed", component: CreatePasswordBoxed },
  { path: "/auth-create-password-modern", component: CreatePasswordModern },

  
  { path: "/announcements/:id", component: AnnouncementDetail },
  // coming soon
  { path: "/pages-coming-soon", component: ComingSoon },

  


  // Error
  //{ path: "/pages-offline", component: Offline },
  { path: "/pages-404", component: Pages404 },

  // Maintenance
  { path: "/pages-maintenance", component: Maintenance },


  // authentication
  { path: "/login", component: Login },
  { path: "/logout", component: Logout },
  { path: "/register", component: Register },

  { path: "/FrequentyAskedQuestions", component: FrequentyAskedQuestions },

// UnverifiedDocs

  { path: "/announcements", component: ViewAnnouncements },
]

export { authProtectedRoutes, publicRoutes };
